.mark {
  width: 22px;
  height: 22px;
  flex: none;
  border-radius: 5px;
  border: 1.5px solid var(--color-accent);
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-template-rows: repeat(3, 1fr);
  overflow: hidden;
}

.mark > span {
  border-right: 1px solid rgb(145 132 217 / 0.5);
  border-bottom: 1px solid rgb(145 132 217 / 0.5);
}

/* The last column and last row sit on the mark's own border. */
.mark > span:nth-child(3n) {
  border-right: 0;
}

.mark > span:nth-child(n + 7) {
  border-bottom: 0;
}

.tinted {
  background: rgb(145 132 217 / 0.4);
}
